import { render } from "./signalementVue.vue?vue&type=template&id=62ac27f0&scoped=true"
import script from "./signalementVue.vue?vue&type=script&lang=js"
export * from "./signalementVue.vue?vue&type=script&lang=js"

import "./signalementVue.vue?vue&type=style&index=0&id=62ac27f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ac27f0"]])

export default __exports__